<template>
	<div>
		<div v-if="pubInfo.pubName" class="detail-header">
			<img :src="pubInfo.images[0].url" height="300" width="400" />
			<div style="margin-left: 16px">
				<div class="detail-title" v-html="pubInfo.pubName"></div>
				<span v-for="(item, index) in pubInfo.tags" :key="index">
					{{ item }}
					<span v-if="index !== pubInfo.tags.length - 1">|</span>
				</span>
				<div class="detail-hint" v-html="pubInfo.specials"></div>
				<div style="margin-top: 20px">
					<el-button :loading="isLoading" size="medium" type="warning" @click.native="onDetailDeal(1)">
						立即投保
					</el-button>
					<el-button
						v-if="!isJiaDian(insureType)"
						:loading="isLoading"
						size="medium"
						type="primary"
						@click.native="onDetailDeal(2)">
						投保计划书
					</el-button>
				</div>
				<div v-if="pubInfo.professionDownload && pubInfo.professionDownload.show === 1" style="margin-top: 15px">
					<el-button
						:loading="isLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 5px"
						type="text"
						@click.native="onDetailDeal(3)">
						{{ pubInfo.professionDownload.label }}
					</el-button>
				</div>
			</div>
		</div>
		<el-tabs v-if="pubDetail.detailModels" v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<div v-if="pubDetail.notices">
					<el-alert
						v-for="(itemData, index) in pubDetail.notices"
						:key="index"
						:closable="false"
						:type="itemData.type"
						show-icon
						style="margin-bottom: 10px">
						<template v-slot:title>
							<span class="u-font-weight-bold" v-html="itemData.content"></span>
						</template>
					</el-alert>
				</div>
				<div v-if="pubDetail.searchForms" style="display: flex; align-items: center">
					<div
						v-for="({label, type, key, options = [], placeholder}, index) in pubDetail.searchForms"
						style="margin: 15px 20px">
						<span style="margin-right: 20px">{{ label }}：</span>
						<el-select
							v-if="type === 'select'"
							v-model="searchData[key]"
							:placeholder="placeholder"
							@change="onChangeSelect(key)">
							<el-option
								v-for="{label: label1, value: value1} in options"
								:key="value1"
								:label="label1"
								:value="value1"></el-option>
						</el-select>
					</div>
				</div>
				<el-card v-for="({content}, index) in pubDetail.detailModels" :key="index">
					<div v-html="content"></div>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-card>
					<el-row>
						<el-col :span="16">
							<div v-for="({question, answer}, index) in pubDetail.productQas" :key="index">
								<span class="answer-custom answer-title" style="font-weight: bold" v-html="question"></span>
								<div style="margin-top: 10px">
									<div class="answer-custom answer-content" style="margin-top: 10px" v-html="answer"></div>
								</div>
								<el-divider></el-divider>
							</div>
						</el-col>
					</el-row>
				</el-card>
			</el-tab-pane>
			<el-tab-pane :label="isLibaoGuzhu(insureType) ? '特别约定' : '投保须知'" name="2">
				<el-card>
					<el-row>
						<el-col :span="22">
							<div v-html="pubDetail.declareContent"></div>
							<div style="margin-top: 20px" v-html="pubDetail.specialAppoint"></div>
						</el-col>
					</el-row>
				</el-card>
			</el-tab-pane>
			<el-tab-pane v-if="pubDetail.attachments && pubDetail.attachments.length > 0" label="下载" name="3">
				<avue-crud ref="crud_content" :data="pubDetail.attachments" :option="downloadOptionData">
					<template slot="menu" slot-scope="{row}">
						<div style="display: flex; justify-content: center; width: 100%">
							<el-button icon="el-icon-download" type="text" @click="onDownload(row)">下载</el-button>
						</div>
					</template>
				</avue-crud>
			</el-tab-pane>

			<el-tab-pane v-if="pubDetail.clauseDesc" label="保险条款" name="4">
				<el-card>
					<el-row>
						<el-col :span="22">
							<div style="margin-top: 20px" v-html="pubDetail.clauseDesc"></div>
						</el-col>
					</el-row>
				</el-card>
			</el-tab-pane>
			<el-tab-pane v-if="pubDetail.productDesc" label="产品说明" name="5">
				<el-card>
					<el-row>
						<el-col :span="22">
							<div style="margin-top: 20px" v-html="pubDetail.productDesc"></div>
						</el-col>
					</el-row>
				</el-card>
			</el-tab-pane>
			<el-tab-pane v-if="pubDetail.claimDesc" label="理赔须知" name="6">
				<el-card>
					<el-row>
						<el-col :span="22">
							<div style="margin-top: 20px" v-html="pubDetail.claimDesc"></div>
						</el-col>
					</el-row>
				</el-card>
			</el-tab-pane>
			<el-tab-pane v-if="pubDetail.dutyExemptDesc" label="责任免除" name="7">
				<el-card>
					<el-row>
						<el-col :span="22">
							<div style="margin-top: 20px" v-html="pubDetail.dutyExemptDesc"></div>
						</el-col>
					</el-row>
				</el-card>
			</el-tab-pane>
			<el-tab-pane v-if="pubDetail.disclosureDesc" label="信息披露" name="8">
				<el-card>
					<el-row>
						<el-col :span="22">
							<div style="margin-top: 20px" v-html="pubDetail.disclosureDesc"></div>
						</el-col>
					</el-row>
				</el-card>
			</el-tab-pane>
			<el-tab-pane v-if="pubDetail.personalInfoProtectDesc" label="个人信息保护政策" name="9">
				<el-card>
					<el-row>
						<el-col :span="22">
							<div style="margin-top: 20px" v-html="pubDetail.personalInfoProtectDesc"></div>
						</el-col>
					</el-row>
				</el-card>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import InsureNotices from './InsureNotices'
import {validatenull} from '../util/validate'
import {downloadOption} from '../option/insureOption'
import {isJiaDian, isLibaoGuzhu} from '../util/productUtil'

export default {
	name: 'InsureInfoDetail',
	components: {InsureNotices},
	props: {
		pubInfo: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		pubDetail: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		isLoading: {
			type: Boolean,
			required: true,
			default: false,
		},
		insureType: Number | String,
	},
	data() {
		return {
			currentStep: '0',
			searchData: {},
			isShowNotices: false,
			noticesData: {},
			downloadOptionData: this.deepClone(downloadOption),
		}
	},
	watch: {
		pubDetail: {
			handler(newVal, oldVal) {
				if (!validatenull(newVal) && validatenull(this.searchData)) {
					//不为空，则处理可选择的数据
					let {searchForms = []} = newVal
					console.log(searchForms, '----')
					if (searchForms.length > 0) {
						for (let searchItem of searchForms) {
							let {key, defaultValue} = searchItem
							this.$set(this.searchData, key, defaultValue)
						}
					}
					console.log(this.searchData, '--')
				}
			},
			immediate: true,
		},
	},
	created() {},
	methods: {
		isJiaDian,
		isLibaoGuzhu,
		//1 投保提醒，2计划书，3 下载职业类别 4,直接进入投保
		onDetailDeal(type) {
			this.$emit('onDetailDeal', type)
		},
		onShowNotices(noticesData) {
			this.noticesData = noticesData
			this.isShowNotices = true
		},
		//详情页搜索
		onChangeSelect(key) {
			console.log(key, '---1')
			//调用接口请求筛选
			this.$emit('onDetailSearch', this.searchData)
		},
		//搜索设置数据
		setSearchData(searchData) {
			Object.assign(this.pubDetail, searchData)
		},
		//下载
		onDownload({url}) {
			window.open(url, '_blank')
		},
	},
}
</script>

<style lang="scss" scoped>
.detail-header {
	display: flex;
	justify-content: left;
	padding: 20px;
}

.detail-title {
	font-size: 26px;
	font-weight: bold;
}

.detail-hint,
.detail-title {
	::v-deep p {
		margin: 10px 0;
	}
}

.answer-custom {
	&:before {
		content: '';
		width: 22px;
		height: 26px;
		color: white;
		line-height: 25px;
		text-align: center;
		border-radius: 4px;
		margin-right: 10px;
		display: inline-block;
	}
}

.answer-title {
	&:before {
		content: 'Q';
		background-color: MediumPurple;
	}
}

.answer-content {
	::v-deep p {
		&:first-child {
			display: inline;
		}

		display: inline-block;
		margin: 8px 0;
	}

	&:before {
		content: 'A';
		background-color: green;
	}
}

.red-bold {
	font-weight: bold;
	color: red;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

::v-deep .el-alert {
	height: 40px;
}
</style>
